import _classCallCheck from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import Modal from '@/components/Modal/index.vue';
import { STATUS } from '@/utils/const';

var Index = /*#__PURE__*/function (_Vue) {
  _inherits(Index, _Vue);

  var _super = _createSuper(Index);

  function Index() {
    var _this;

    _classCallCheck(this, Index);

    _this = _super.apply(this, arguments);
    _this.showModal = false;
    return _this;
  }

  _createClass(Index, [{
    key: "videoBtnClickHandler",
    value: function videoBtnClickHandler() {
      if (this.inNotReady || this.inProblem || this.inPrepareReplay) {
        this.showModal = true;
      } else {
        // this.$router.push({ name: 'live' });
        var newWindow = window.open("".concat(location.href, "live"), '_blank');

        if (newWindow) {
          newWindow.opener = null;
        }
      }
    }
  }, {
    key: "cancelHandler",
    value: function cancelHandler() {
      this.showModal = false;
    }
  }, {
    key: "inNotReady",
    get: function get() {
      return this.homeData.status <= STATUS.PRE_LIVE;
    }
  }, {
    key: "inLive",
    get: function get() {
      // return this.homeData.status >= STATUS.PRE_LIVE && this.homeData.status <= STATUS.LIVE;
      return this.homeData.status === STATUS.LIVE;
    }
  }, {
    key: "inProblem",
    get: function get() {
      return this.homeData.status === STATUS.IN_FIX;
    }
  }, {
    key: "inPrepareReplay",
    get: function get() {
      return this.homeData.status === STATUS.CONF_REPLAY;
    }
  }, {
    key: "inReplay",
    get: function get() {
      return this.homeData.status >= STATUS.REPLAY;
    }
  }]);

  return Index;
}(Vue);

__decorate([Prop({
  required: true,
  default: {}
})], Index.prototype, "homeData", void 0);

Index = __decorate([Component({
  name: 'ViewBanner',
  components: {
    Modal: Modal
  }
})], Index);
export default Index;